import { ReactNode } from "react"
import { Card, CardBody, Row, Col } from "reactstrap"

interface DetailPageHeaderRow {
    label: string
    value: ReactNode
}

interface DetailPageHeaderProps {
    title: ReactNode
    subtitle?: ReactNode
    rows?: DetailPageHeaderRow[]
    actions?: ReactNode
    accentColor?: string | null
    // Use the whole card width for the title block (when the card itself sits in a half-width column)
    fullWidth?: boolean
    // Extra content under the rows (e.g. the Project Health summary)
    footer?: ReactNode
}

const DetailPageHeader = ({ title, subtitle, rows, actions, accentColor, fullWidth, footer }: DetailPageHeaderProps) => {
    return <Card
        className={`mb-0`}
        style={accentColor ? { borderBottomColor: accentColor, borderBottomWidth: '4px' } : undefined}
    >
        <CardBody>
            <Row className="align-items-start g-3">
                <Col xs={12} md={fullWidth ? 12 : 6}>
                    <h2 className="mb-1">{title}</h2>
                    {subtitle && <p className="text-muted mb-2">{subtitle}</p>}
                    {rows && rows.length > 0 && (
                        <div className="d-flex flex-wrap gap-2">
                            {rows.map(({ label, value }, i) => (
                                <div key={i} className="d-flex gap-1">
                                    <span className="fw-semibold">{label}:</span>
                                    <span>{value}</span>
                                </div>
                            ))}
                        </div>
                    )}
                    {footer && <div className="mt-3">{footer}</div>}
                </Col>
                {actions && (
                    <Col xs={12} md={6} className="d-flex flex-wrap gap-2 justify-content-md-end">
                        {actions}
                    </Col>
                )}
            </Row>
        </CardBody>
    </Card>
}

export default DetailPageHeader
